import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {PortalTimezoneService} from '../../services/portal-timezone.service';
import {AuthService} from '../../../../../core/service/auth.service';
import {MessagingService} from '../../../../../core/service/messaging.service';
import {VnaPortalSelected} from '../../../../../core/data/messaging/VnaPortalSelected';

const SELECT_TIMEZONE_VALUE_ACCESSOR: any = {
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectTimezoneComponent)
};

@Component({
    selector: 'app-select-timezone',
    template: `
      <ngx-select [items]="timezones" [(ngModel)]="timezone" [optionValueField]="valueField" [optionTextField]="textField" allowClear="true">
          <ng-template ngx-select-option ngx-select-option-selected let-option let-text="text">
              {{ option.data.timezone }} <br />
          </ng-template>
      </ngx-select>
      `,
    styleUrls: ['./select-timezone.component.scss'],
    providers: [SELECT_TIMEZONE_VALUE_ACCESSOR]
})
export class SelectTimezoneComponent implements OnInit, ControlValueAccessor {

    @Input() valueField: string = 'pk';
    @Input() textField: string = 'name';

    timezones: Array<Object> = [];
    _timezone: number;

    constructor(private timezoneHandler: PortalTimezoneService, private auth: AuthService, private messaging: MessagingService) { }

    ngOnInit() {
        this.getTimezones();
        this.messaging.message.subscribe(
            (result) => {
                if(result instanceof VnaPortalSelected && !result.isTheFirst()){
                    this.getTimezones();
                }
            }
        )
    }

    protected getTimezones(): void {
        this
            .timezoneHandler
            .findTimezonesByPortalPk(this.auth.getPkPortal())
            .subscribe(
                (result) => {
                    this.timezones = result;
                }
            )
        ;
    }

    selected(value: any) {
        this.propagateChange(this._timezone);
    }


    get timezone(): any { return this._timezone; };

    set timezone(v: any) {
        this._timezone = v;
        this.propagateChange(this._timezone);
    }

    propagateChange = (_: any) => {};

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
    }

    writeValue(value: any): void {
        this._timezone = value;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_portal/components/select-timezone/select-timezone.component.ts